import { render } from "./ResearchSlider.vue?vue&type=template&id=1285008e"
import script from "./ResearchSlider.vue?vue&type=script&lang=js"
export * from "./ResearchSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__